import React from 'react'
import Image from '@components/image'
import { Link } from 'gatsby'
import { linkProps } from '@utils/general'

const BundleItem = ({ title, color, listingVariantTitle, listingImage, variantImages, variantColor, link}) => {
  const { to, href }  = {...linkProps(link, null)}

  return (
    <Link to={to} href={href} className={`flex flex-col gap-y-5 mx-[5px] lg:mx-2.5`} aria-label={`Bundle Item: ${title} ${variantColor?.length > 0 ? `in ${color}` : `in ${listingVariantTitle}`}`}>
      <Image image={listingImage || variantImages[0]} width="520" height="520" className={'rounded-xl'} alt={title + " product image"} />
      <p className="text-base inline-flex items-baseline gap-1">
        <b>{title}</b> 
        {variantColor?.length > 0 ? (
          <>
            {' in '}
            <span 
              className="rounded-xl inline-block w-3 h-3 relative top-1/2 " 
              style={{ backgroundColor: variantColor?.length > 0 ? variantColor[0]?.color?.hex : '' }}>
            </span>
            {color || variantColor[0].colorName}
          </>
        ) : (
          <>
            {' in '}
            <span>{listingVariantTitle}</span>
          </>
        )}
      </p>
    </Link>
  )
}

export default BundleItem